import "./PopOversComponent.scss";
import * as React from "react";
import Popover from '@mui/material/Popover';

import {useCallback} from "react";

interface PopOversComponentProps {
    id?: string;
    isOpen: boolean;
    className?: string;
    closeOnEsc?: boolean;
    closeOnBackDropClick?: boolean;
    onClose?: () => void;
    anchorEl?: HTMLElement | null;
    anchorOrigin?:any
    transformOrigin?:any
}

const PopOversComponent = (props: React.PropsWithChildren<PopOversComponentProps>) => {
    const { id, isOpen, children, onClose, anchorEl, anchorOrigin, transformOrigin,className } = props;

    const handleOnClose = useCallback(() => {
        if (onClose) {
            onClose();
        }
    }, [onClose]);

    return (
        <div className={'pop-overs-component'}>
            <Popover
                id={id}
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleOnClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                <div className={`popover-content ${className ? className : ""}`}>
                    {children}
                </div>
            </Popover>
        </div>
    );
};

export default PopOversComponent;
